const n = /* @__PURE__ */ new Map(), h = !0;
async function f(a, t, c, r, i = !1) {
  if (n.size === 0 || i)
    return !1;
  try {
    if (t.method === "GET") {
      if (n.has(a)) {
        const e = n.get(a), o = new Response(JSON.stringify(e.data), {
          headers: {
            "Content-Type": "application/json"
          }
        });
        return c(o), !0;
      }
    } else if (t.method === "PUT" || t.method === "POST" || t.method === "DELETE") {
      let e = a.split("/");
      t.method !== "POST" && e.pop(), e = e.join("/"), n.has(e) && n.delete(e);
    }
    return !1;
  } catch (e) {
    r(e);
  }
}
async function s(a, t, c, r, i) {
  try {
    if (h) return r(c);
    if (t.method === "GET") {
      const e = await c.clone().json();
      n.set(a, {
        time: Date.now(),
        data: e
      });
    }
    return r(c);
  } catch (e) {
    i(e);
  }
}
export {
  s as createCache,
  f as fetchCache
};
